import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import Galary from "../../../utils/galary"
const Details = ({ adv: { _id, title, discription,imagegalary } }) => {
  const [addModals, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <Fragment>
      {/*  eslint-disable-next-line */}
      <a className="btn btn-dark text-white" onClick={handleShow}>
        {" "}
        التفاصيل
      </a>
      <Modal show={addModals} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {" "}
            <h5 className="center-align">{title}</h5>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ lineHeight: "2.4rem", fontSize: "1.3rem" }}>
            <ul className="right-align">
              <li
                dangerouslySetInnerHTML={{ __html: discription }}
                className="text-justify p-2"
              ></li>
            </ul>
            <Galary pictures={imagegalary} />
          </div>
          <Modal.Footer>
            <button
              className="btn-custom btn-dark center"
              onClick={handleClose}
            >
              اغلاق
            </button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default Details;
